import './MappingTag.scss';
import React, { useEffect, useRef, useState } from 'react';
import { FlightTooltip } from '@flybits/design-system';

const MAIN_CLASS = 'attributes-mapping-tag';
const CLASSES = {
  CONTAINER: `${MAIN_CLASS}__container`,
  TEXT: `${MAIN_CLASS}__container__text`,
};
interface MappingTagProps {
  tag: string;
}

/**
 * Renders a tag inside a styled container with a tooltip.
 *
 * @param props - The props for the MappingTag component.
 * @param props.tag - The string value to display and use as the tooltip description.
 * @returns A React element displaying the tag with a tooltip.
 */
const MappingTag: React.FC<MappingTagProps> = ({ tag }) => {
  const [isTagOverflowing, setIsTagOverflowing] = useState(false);
  const tagRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tagRef.current) {
      const isOverflow = tagRef.current.scrollWidth > tagRef.current.clientWidth;
      setIsTagOverflowing(isOverflow);
    }
  }, [tag]);
  return (
    <div className={MAIN_CLASS}>
      <div className={CLASSES.CONTAINER}>
        <FlightTooltip description={tag} direction="bottom" isEnabled={isTagOverflowing}>
          <div className={CLASSES.TEXT} ref={tagRef}>
            {tag}
          </div>
        </FlightTooltip>
      </div>
    </div>
  );
};

export default MappingTag;
